<template>
  <div class="main-body">
    <div class="header">老人IC卡管理</div>
    <div class="out">
      <div class="search2">

          <div style="float:right">

            <el-input placeholder="请输入姓名" v-model="name" maxlength="11" clearable style="width:200px;margin-right:10px"></el-input>
            <el-input placeholder="请输入手机号" v-model="phone" maxlength="11" clearable style="width:200px;margin-right:10px"></el-input>

            <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                          placeholder="选择区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                          style="width:200px;margin-right:10px"></elSelectTree>

            <el-button type="primary" size="mini" icon="el-icon-search" @click="getList">搜索</el-button></div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border style="width: 100%;"
                v-loading="loading" :row-class-name="tableRowClassName">

        <el-table-column prop="name" fixed="left" label="姓名" width="200"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="200"></el-table-column>
        <el-table-column prop="icCard" label="IC卡号" ></el-table-column>
        <el-table-column prop="icCardStatus" :formatter="icCardStatus" label="IC卡状态" width="150px"></el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>


  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import elderly from "@/common/status";
import {getStaffCode} from "@/utils/auth";

import elSelectTree from "@/components/ElSelectTree"

export default {
  name: "Page",
  data() {
    return {
      uploadUrl:this.$shopUrl+'ImportExcel/Import',
      uploadData:{
        staffCode:getStaffCode(),
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
      },
      batchFileList:[],
      ICCardDialog:false,
      icCard:'',
      elderlyCode:'',
      batchDialog:false,
      batchDialogError:false,
      errorData:[],
      showModal:false,
      showModalDevice:false,
      censusRegister:'',
      loading: false,
      showModalAdd: false,
      showModalOldManFile: false,
      datetimerangeValue: '',
      showModalEdit: false,
      showModalSearch: false,
      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: 0,
      name: '',
      idCard: '',
      ctiyDate: [],
      elderlyType: elderly.serviceType,
      elderlyClassValue: [],
      nationValue: [],
      elderlyAllType: elderly,


      phone: '',
      elderlyClassList:'',
      elderlyClass:-1,
      censusRegisterList:['城市','农村'],

      status:-1,
      statusList: [
        {
          value: -1, label: '全部状态'
        }, {
          value: 1, label: '正常'
        }, {
          value: 2, label: '禁用'
        }
      ],

      zoneValue: [],
      zoneCode: '',
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },


    }


  },
  components: {
    elSelectTree
  },

  created() {
    this.init();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {
    init: function () {
      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 365);
      this.datetimerangeValue = [start, end];

      this.getZone();

    },

    getZoneValue(val) {
      this.zoneCode = val
    },
    getTime(row,index,column){
      return timefilters(column)
    },
    tableRowClassName({row}) {
      const timeAudit = new Date(row.timeAudit);
      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
      if (timeAudit >= start) {
        return 'success-row';
      }
      return '';
    },


    bindCard(row){
      this.ICCardDialog=true;
      this.icCard=''
      this.elderlyCode=row.elderlyCode
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.loading=true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/PageByZoneCodeForIcCard",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),

          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          phone: this.phone,
          name:this.name,
          zoneCode:this.zoneCode,

        }
      }).then((response) => {
        this.loading=false;
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        this.loading=false;
        console.log(error);
      });
    },

    bindSubmit(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/BindIcCard",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          icCard:this.icCard,
          elderlyCode:this.elderlyCode
        }
      }).then((response) => {
        this.loading=false;
        if (response.data.error == 0) {
          this.ICCardDialog=false
          this.getList()
          this.$message({type: 'success', message: '绑定成功'});
        } else if (response.data.error == 1) {
          this.$message({type: 'error', message: response.data.message});

        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    FrozenCard(row){
      this.$confirm('是否为此卡挂失?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          url: this.$shopUrl + "CardStatus/FrozenCard",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            cardNumber:row.icCard,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
            this.$message({type: 'success', message: '挂失成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消挂失！'
        });
      });
    },
    ThawCard(row){
      this.$confirm('是否解冻此卡?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          url: this.$shopUrl + "CardStatus/ThawCard",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            cardNumber:row.icCard,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
            this.$message({type: 'success', message: '解冻成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解冻！'
        });
      });
    },
    icCardStatus(row) {
      if (row.icCardStatus == 1) {
        return "已绑定";
      }
      if (row.icCardStatus == 2) {
        return "挂失";
      }
      return "未绑定";
    },
    politics(row) {
      return this.allStatus(row.politicsStatus, elderly.politicalOutlook);
    },
    censusRegisters(row) {
      return this.allStatus(row.censusRegister, elderly.natureHRegistrater);
    },
    educations(row) {
      return this.allStatus(row.education, elderly.education);
    },
    allStatus(row, status) {
      for (var i in status) {
        if (status[i].value == row) {
          return status[i].label
        }
      }
      return "其它";
    },


    getZone(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        //console.log(response.data.data);
        if (response.data.error == 0) {
          var data = JSON.stringify(response.data.data);

          //console.log(data.replace(/"listZoneDTO":\[\],/g, ''));

          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
          this.zoneValue = data;
          this.zoneCode = data[0].zoneCode;

          this.getList();

        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },



  }
}
</script>

<style>
.el-table .success-row {
  background: #f0f9eb;
}
</style>
<style   lang="scss" scoped>
.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}
.mask .lodingsIcon{
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}
.lodingsIcon i{
  z-index: 200;
  font-size: 25px;
  margin-right:10px ;

}

.label{
  padding: 5px 0px;
}
</style>
